const onlyAllowedAndLatinLetters = (str: string) => {
  if (!str) return false
  const remaining = str.replace(/[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?\\|\-=~№`/ ]/g, '')
  return remaining.length === 0
}

export default onlyAllowedAndLatinLetters
